import { Directive, booleanAttribute, input } from '@angular/core';

@Directive({
  selector: '[glxyButtonShowProgress]',
  host: {
    class: 'glxy-button-show-progress-host',
    '[attr.aria-busy]': 'showProgress() ? "true" : null',
    '[class.glxy-button-progress-indicator-shown]': 'showProgress()',
  },
})
export class GlxyButtonShowProgressDirective {
  readonly showProgress = input(false, {
    alias: 'glxyButtonShowProgress',
    transform: booleanAttribute,
  });
}
